import axios from "axios";
import { refreshAccessToken, logoutUser } from "./tokenUtils";

const RAW_BASE = process.env.REACT_APP_API_BASE_URL || ""
const API_BASE_URL = RAW_BASE.replace(/\/+$/, "");
if (!API_BASE_URL) {
  console.warn("REACT_APP_API_BASE_URL is NOT set. Requests will hit the frontend origin.");
}
const axiosClient = axios.create({
  baseURL: API_BASE_URL,
  headers: { "Content-Type": "application/json" },
  withCredentials: false,  // using JWT in Authorization header
  timeout: 10000,
});

axiosClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("access_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config
});

axiosClient.interceptors.response.use(
  (response) => response, // Pass successful responses through
  async (error) => {
    if (error.response?.status === 401 && !error.config.__isRetry) {
      // If access token is expired, try refreshing it
      try {
        await refreshAccessToken();
        error.config.__isRetry = true;
        return axiosClient(error.config); // Retry the original request
      } catch {
        logoutUser(); // Logout if refresh fails
        window.location.href = "/"; // Redirect to login
      }
    }
    return Promise.reject(error);
  }
);

export default axiosClient;
